const Resources = {

    table_headers: [
        { 
            text:  'Name',
            align: 'start',
            value: 'name',
            type:  'link',
            event: true,
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Options',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Groups',
            href:   '/options-groups',
            arrow:  "",
        },
    ],

}

export default Resources;